import Tasks from 'APP/Tasks';

export const loadUsers = async (usersIds) => {
  if (usersIds.length > 0) {
    await Tasks.relationships.loadUnknownUsersByIds({
      usersIds,
    });
  }
};
